module.exports = __webpack_public_path__ + "img/ATRC Platform - Privacy Policy -7.82ec476b.png";